
import { supabase } from '@/integrations/supabase/client';
import { Terrace } from '@/types/terrace';
import { toast } from 'sonner';

export const useTerraceOperations = (refetchTerraces: () => Promise<void>) => {
  const updateTerrace = async (id: string, updates: Partial<Terrace>) => {
    try {
      // Convert DetailedOpeningHours to Json format for database storage
      const detailedOpeningHoursJson = updates.detailed_opening_hours 
        ? JSON.stringify(updates.detailed_opening_hours)
        : undefined;

      const { error } = await supabase
        .from('terraces')
        .update({
          name: updates.name,
          address: updates.address,
          type: updates.type,
          opening_hours: updates.openingHours,
          detailed_opening_hours: detailedOpeningHoursJson,
          orientation: updates.orientation,
          has_food: updates.hasFood,
          pet_friendly: updates.petFriendly,
          serves_alcohol: updates.servesAlcohol,
          terrace_description: updates.terraceDescription,
          website: updates.website,
          phone: updates.phone,
          sun_status: updates.sunStatus,
          photo_url: updates.photo_url, // Add photo_url to the update
          updated_at: new Date().toISOString()
        })
        .eq('id', id);

      if (error) {
        console.error("Error updating terrace:", error);
        toast.error("Failed to update terrace");
        return false;
      }

      toast.success("Terrace updated successfully");
      await refetchTerraces(); // Refresh the list
      return true;
    } catch (err) {
      console.error("Error updating terrace:", err);
      toast.error("Failed to update terrace");
      return false;
    }
  };

  const deleteTerrace = async (id: string) => {
    try {
      const { error } = await supabase
        .from('terraces')
        .delete()
        .eq('id', id);

      if (error) {
        console.error("Error deleting terrace:", error);
        toast.error("Failed to delete terrace");
        return false;
      }

      toast.success("Terrace deleted successfully");
      await refetchTerraces(); // Refresh the list
      return true;
    } catch (err) {
      console.error("Error deleting terrace:", err);
      toast.error("Failed to delete terrace");
      return false;
    }
  };

  return {
    updateTerrace,
    deleteTerrace
  };
};
